import { formatUsd, formatUsdWhole } from '@/lib/format'

/**
 * A card header's flow buttons (Holdings: Swap, Deposit, Withdraw; Kraken: Sell, Withdraw): a 32px square around the
 * icon until the words fit beside the figure (lg, with the sidebar open), then the button's own padding and the word
 * (John, Nov 3 2026: the icon view must be square, not the button's taller padding).
 */
export const HEADER_BTN = 'btn shrink-0 p-2 lg:px-4 lg:py-2.5'

/**
 * A card header's dollar total, after the title and its divider (John, Nov 3 2026: "Holdings | $27,623.45").
 * Phones get whole dollars: with the cents, the Holdings row (total, three icon buttons, the filter) ran past a 390px
 * screen and wrapped; from sm up the cents are back.
 */
export function CardFigure({ usd }: { usd: number | null | undefined }) {
  return (
    <span className="card-figure">
      <span className="sm:hidden">{formatUsdWhole(usd)}</span>
      <span className="hidden sm:inline">{formatUsd(usd)}</span>
    </span>
  )
}
